module.exports = __webpack_public_path__ + "static/img/联系我们_banner.ff98996.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/联系我们_banner.png
// module id = H4FG
// module chunks = 1